import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, FileText, MessageSquare, MessagesSquare, Mail, ArrowRight } from "lucide-react";
import api from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Pending Bookings", value: stats?.bookings_pending, total: stats?.bookings_total, to: "/admin/bookings", icon: CalendarCheck, color: "bg-brand-emerald", tid: "stat-pending-bookings" },
    { label: "Blog Posts", value: stats?.posts, to: "/admin/posts", icon: FileText, color: "bg-brand-lime", tid: "stat-posts" },
    { label: "Comments to Moderate", value: stats?.comments_pending, to: "/admin/comments", icon: MessageSquare, color: "bg-brand-gold", tid: "stat-pending-comments" },
    { label: "Open Live Chats", value: stats?.chats_open, to: "/admin/chat", icon: MessagesSquare, color: "bg-sky-600", tid: "stat-open-chats" },
    { label: "Unread Contacts", value: stats?.contacts_unread, to: "/admin/contacts", icon: Mail, color: "bg-rose-600", tid: "stat-unread-contacts" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-brand-emerald">Dashboard</h1>
        <p className="text-brand-muted text-sm mt-1">Welcome back. Here's what needs your attention.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} data-testid={c.tid} className="bg-white rounded-2xl border border-[#D6E4DC] p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all group">
            <div className={`w-11 h-11 rounded-xl ${c.color} flex items-center justify-center mb-4`}>
              <c.icon className="w-5 h-5 text-white" />
            </div>
            <p className="font-display text-3xl font-extrabold text-brand-ink">{stats ? c.value ?? 0 : "—"}</p>
            <p className="text-xs font-bold text-brand-muted uppercase tracking-wider mt-1 flex items-center justify-between">
              {c.label} <ArrowRight className="w-3.5 h-3.5 text-brand-lime opacity-0 group-hover:opacity-100 transition-opacity" />
            </p>
          </Link>
        ))}
      </div>
      <div className="mt-8 bg-brand-mint rounded-2xl border border-[#D6E4DC] p-6">
        <h2 className="font-display font-bold text-brand-emerald mb-2">Quick tips</h2>
        <ul className="text-sm text-brand-muted space-y-1.5 list-disc ml-5">
          <li>Confirm pending bookings in <strong>Bookings</strong>, then call the customer to lock the slot.</li>
          <li>Reply to live chats in the <strong>Chat Desk</strong> — visitors see your replies instantly in the widget.</li>
          <li>Publish cleaning tips regularly from <strong>Blog Posts</strong> to boost your Google ranking.</li>
        </ul>
      </div>
    </div>
  );
}
